import React, { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Table,
  Tooltip,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  styled,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import base64 from "base64-js";
import { useParams } from "react-router-dom";


const AddExam = () => {
  const [canSave, setCanSave] = useState(false);
  const [showUserGuide, setShowUserGuide] = useState(false);
  const [examTypes, setExamTypes] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [session, setSession] = useState("");
  const [subExams, setSubExams] = useState([]);
  const [teacherData, setTeacherData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [subjectOption, setSubjectOption] = useState("withSubject");
  const [selectedExamType, setSelectedExamType] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubExam, setSelectedSubExam] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [isWithSubject, setIsWithSubject] = useState(true);
  const [studentList, setStudentList] = useState([]);
  const [showSaveCancel, setShowSaveCancel] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isExamModeIndependent, setIsExamModeIndependent] = useState(0);
  const [isSubExamDisabled, setIsSubExamDisabled] = useState(false);
  const [selectAll, setSelectAll] = useState(false);




const decodeFormId = (encodedFormId) => {
        if (!encodedFormId || typeof encodedFormId !== "string") {
            console.error("encodedFormId is missing or invalid:", encodedFormId);
            return null;
        }
        try {
            const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
            const bytes = base64.toByteArray(paddedEncodedFormId);
            return new TextDecoder().decode(bytes);
        } catch (error) {
            console.error("Error decoding formId:", error);
            return null;
        }
    };

const { encodedFormId } = useParams();
const formId = decodeFormId(encodedFormId);

const Authorizer = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ formId }),
    });
    if (response.ok) {
      const responseData = await response.json();
      const authorizationData = responseData[0];
      setCanSave(authorizationData.uWrite === 1);
    } else {
      console.error("Authorization failed:", response.status);
      alert("Invalid authorization response");
    }
  } catch (error) {
    console.error("API request error:", error);
    alert("An error occurred. Please try again later.");
  }
};


const handleSubjectOptionChange = (event) => {
  setSubjectOption(event.target.value);
  setIsWithSubject(event.target.value === "withSubject");
  setStudentList([]);
  setShowSaveCancel(false);
  setSelectAll(false);
};

  useEffect(() => {
    if (subjectOption === "withoutSubject") {
      setSelectedSubject("");
    }
  }, [subjectOption]);

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: 20,
    padding: "8px 24px",
    textTransform: "none",
    fontWeight: 600,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  }));


  const fetchSessions = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/ClassPromotion/GetFinancialYear`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        setSessions(data);

        const today = new Date();
        const currentYear = today.getFullYear();
        const nextYear = currentYear + 1;

        const financialYearStart = new Date(currentYear, 3, 1);
        const financialYearEnd = new Date(nextYear, 2, 31);

        let currentSessionString;
        if (today >= financialYearStart && today <= financialYearEnd) {
          currentSessionString = `${currentYear}-${nextYear}`;
        } else {
          currentSessionString = `${currentYear - 1}-${currentYear}`;
        }

        const currentSession = data.find(
          (item) => item.finanacialYear === currentSessionString
        );

        if (currentSession) {
          setSession(currentSession.financialYearID);
        }
      }
    } catch (error) {
      console.error("Error fetching financial years:", error);
      setSnackbarMessage("Failed to fetch sessions.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    const fetchExamTypes = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_URL}/ExaminationCriteria/GetExaminationCriteria`;
        const token = sessionStorage.getItem("token");

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ examCategoryId: 0 }),
        });

        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();

        if (Array.isArray(data) && data.length > 0) {
          setExamTypes(data);
        } else {
          setSnackbarMessage("No exam types found.");
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error fetching exam types:", error);
        setSnackbarMessage("Failed to fetch exam types. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    };

    fetchExamTypes();
    Authorizer();
  }, []);

  useEffect(() => {
    if (!selectedExamType) return;

    const selectedExam = examTypes.find(
      (exam) => exam.examType === selectedExamType
    );

    if (selectedExam) {
      setIsExamModeIndependent(selectedExam.isExamModeIndependent);

      if (selectedExam.isExamModeIndependent === 1) {
        setSnackbarMessage(
          "Sub-exam selection is disabled as the exam mode is independent."
        );
        setSnackbarSeverity("info");
        setSnackbarOpen(true);
        setIsSubExamDisabled(true);
      } else {
        setIsSubExamDisabled(false);
      }
    }
  }, [selectedExamType, examTypes]);

  useEffect(() => {
    if (!selectedExamType || isExamModeIndependent === 1) return;

    const fetchSubExams = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_URL}/Teacher/ddlExamSubCategory_Examination`;
        const token = sessionStorage.getItem("token");

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ examCategoryId: selectedExamType }),
        });

        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();

        if (Array.isArray(data) && data.length > 0) {
          setSubExams(
            data.map((subExam) => ({
              id: subExam.examSubCategoryId,
              name: subExam.examSubCategory,
            }))
          );
          setIsSubExamDisabled(false);
        } else {
          setSubExams([]);
          setSnackbarMessage("No sub-exams found for the selected exam type.");
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
          setIsSubExamDisabled(true);
        }
      } catch (error) {
        console.error("Error fetching sub-exams:", error);
        setSnackbarMessage("Failed to fetch sub-exams. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setIsSubExamDisabled(true);
      }
    };

    fetchSubExams();
  }, [selectedExamType, isExamModeIndependent]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const fetchddlTeacher = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Exam/ddlTeacher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const responseData = await response.json();

        if (responseData.data !== null) {
          setTeacherData(responseData);
        } else {
          console.error("No data found for teachers");
          setSnackbarMessage("No teachers found.");
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }

        if (responseData.msg && responseData.msg !== "Record Not Found") {
          console.error("API error:", responseData.msg);
          setSnackbarMessage(responseData.msg);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } else {
        console.error("Failed to fetch teacher data");
        setSnackbarMessage("Failed to fetch teachers.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("Error fetching teachers. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const fetchClasses = async (teacherId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Exam/GetClass`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ teacherId }),
      });

      if (response.ok) {
        const responseData = await response.json();

        if (responseData.msg === null) {
          setSnackbarMessage("No classes found for this teacher.");
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
          setClassData([]);
          return;
        }
        setClassData(responseData);
      } else {
        console.error("Failed to fetch class data");
        setSnackbarMessage("Failed to fetch classes.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("Error fetching classes. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const fetchSections = async (teacherId, classId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Exam/ddlSection_clsId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ teacherId, classId }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setSectionData(Array.isArray(responseData) ? responseData : []);
      } else {
        console.error("Failed to fetch section data");
        setSnackbarMessage("Failed to fetch sections.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setSectionData([]);
      }
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("Error fetching sections. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setSectionData([]);
    }
  };

  const fetchSubjects = async (classId, sectionId, teacherId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Exam/Subjectddl`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ classId, sectionId, teacherId }),
      });

      if (response.ok) {
        const responseData = await response.json();

        // Ensure response is an array, handle different response structures
        let subjects = [];
        if (Array.isArray(responseData)) {
          subjects = responseData;
        } else if (responseData && Array.isArray(responseData.data)) {
          subjects = responseData.data;
        } else {
          subjects = [];
        }

        setSubjectData(subjects);

        if (subjects.length === 0) {
          setSnackbarMessage(
            "No subjects found for the selected class and section."
          );
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }
      } else {
        console.error("Failed to fetch subject data");
        setSnackbarMessage("Failed to fetch subjects.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setSubjectData([]);
      }
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("Error fetching subjects. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setSubjectData([]);
    }
  };

  useEffect(() => {
    fetchddlTeacher();
    fetchSessions();
  }, []);

  useEffect(() => {
    if (selectedTeacher !== "") {
      fetchClasses(selectedTeacher);
    } else {
      setClassData([]);
      setSectionData([]);
      setSubjectData([]);
    }
  }, [selectedTeacher]);

  useEffect(() => {
    if (selectedTeacher !== "" && selectedClass !== "") {
      fetchSections(selectedTeacher, selectedClass);
    } else {
      setSectionData([]);
      setSubjectData([]);
    }
  }, [selectedTeacher, selectedClass]);

  useEffect(() => {
    if (
      selectedClass !== "" &&
      selectedSection !== "" &&
      selectedTeacher !== ""
    ) {
      fetchSubjects(selectedClass, selectedSection, selectedTeacher);
    } else {
      setSubjectData([]);
    }
  }, [selectedClass, selectedSection, selectedTeacher]);

  const handleGetStudents = async () => {
    if (
      !selectedExamType ||
      (!isSubExamDisabled && !selectedSubExam) ||
      !selectedClass ||
      !selectedSection ||
      !selectedTeacher ||
      (subjectOption === "withSubject" && !selectedSubject)
    ) {
      setOpenDialog(true);
      return;
    }
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Exam/GetStudentList_Exam`;
      const token = sessionStorage.getItem("token");

      // Find the selected exam type to get its isExamModeIndependent value
      const selectedExam = examTypes.find(
        (exam) => exam.examCriteriaId === selectedExamType
      );
      const isExamModeIndependentValue = selectedExam
        ? selectedExam.isExamModeIndependent === 1
        : false;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          classId: selectedClass,
          sectionId: selectedSection,
          subjectId: selectedSubject || 0,
          examTypeId: selectedExamType,
          subCategoryId: selectedSubExam || 0,
          isWithSubject: isWithSubject,
          isExamModeIndependent: isExamModeIndependentValue,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setStudentList(Array.isArray(responseData) ? responseData : []);
        if (!Array.isArray(responseData) || responseData.length === 0) {
          setSnackbarMessage("No students found for the selected criteria.");
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }
      } else {
        console.error("Failed to get student list");
        setSnackbarMessage("Failed to fetch student list.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("Error fetching student list. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
    setShowSaveCancel(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const clearForm = () => {
    
    setSelectedExamType(""); // Reset exam type dropdown
    setSelectedSubExam(""); // Reset sub-exam dropdown
    setSelectedTeacher(""); // Reset teacher dropdown
    setSelectedClass(""); // Reset class dropdown
    setSelectedSection(""); // Reset section dropdown
    setSelectedSubject(""); // Reset subject dropdown
    setSubjectOption("withSubject"); // Reset subject option to default
    setStudentList([]); // Clear student list
    setSelectedSubject("");
    setShowSaveCancel(false); // Hide save/cancel buttons
    setSelectAll(false); // Reset select all checkbox
  };

  const handleSave = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Exam/SaveStudentMarks`;
      const token = sessionStorage.getItem("token");

      const selectedStudents = studentList.filter((student) => student.checked);

      if (selectedStudents.length === 0) {
        setSnackbarMessage("Please select at least one student to save marks.");
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
        return;
      }

      const requestBody = selectedStudents.map((student) => ({
        examTypeId: selectedExamType,
        studentId: student.studentId,
        classId: selectedClass,
        sectionId: selectedSection,
        subjectId: selectedSubject || 0,
        maxMarks: student.maxMarks,
        minMarks: student.minMarks,
        obtainedMarks: student.obtainedMarks,
        subExamCategoryId: selectedSubExam || 0,
        isSubject: isWithSubject,
        isAttendedExam: true,
        sessionId: session,
      }));

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        setStudentList([]);
        setSelectedSubject("");
        setSnackbarMessage("Data saved successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage("Failed to save data.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("Error saving data. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

 const handleSessionChange = (event) => {
  setSession(event.target.value);
  setStudentList([]);
  setShowSaveCancel(false);
  setSelectAll(false);
};

  const handleCheckboxChange = (index, checked) => {
    setStudentList((prevList) =>
      prevList.map((student, idx) =>
        idx === index ? { ...student, checked } : student
      )
    );
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setStudentList((prevList) =>
      prevList.map((student) => ({ ...student, checked: isChecked }))
    );
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '1px auto',
          maxWidth: "900px",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', textAlign: 'center', fontWeight: 'bold' }}>

          Exam  <InfoIcon onClick={() => setShowUserGuide(true)} style={{ "opacity": "0.6" }} />
        </Typography> </Box>

      <Dialog
        open={showUserGuide}
        onClose={() => setShowUserGuide(false)}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            backgroundColor: "#f9fafb",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(90deg, #1898c2 0%, #beab6c 100%)",
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            borderRadius: "12px 12px 0 0",
            py: 2,
          }}
        >
          Exam User Guide
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Typography
            variant="h6"
            sx={{
              color: "#1898c2",
              fontWeight: "600",
              mb: 2,
              mt: 1,
              textAlign: "center",
            }}
          >
            Quick Steps to take Exam
          </Typography>
          <Box
            component="ul"
            sx={{
              listStyleType: "none",
              padding: 0,
              "& li": {
                display: "flex",
                alignItems: "flex-start",
                mb: 1.5,
                fontSize: "1.0rem",
                color: "#333",
              },
              "& li::before": {
                content: '"\\2022"', // Bullet point
                color: "#1898c2",
                fontWeight: "bold",
                display: "inline-block",
                width: "1.5em",
                mr: 1,
                fontSize: "1.2rem",
              },
              "& strong": {
                margin: "0 0.2em", // Add spacing around strong tags
              },
              "& em": {
                margin: "0 0.2em", // Add spacing around strong tags
              },
            }}
          >
            <li>Select a <strong>Session</strong> from the dropdown menu.</li>
            <li>Choose whether the exam is <strong>With Subject</strong> or <strong>Without Subject</strong> using the radio buttons.</li>
            <li>Select an <strong>Exam Type</strong> from the dropdown menu.</li>
            <li>If applicable, select a <strong>Sub Exam</strong> from the dropdown menu.</li>
            <li>Select a <strong>Teacher</strong> from the dropdown menu.</li>
            <li>Select a <strong>Class</strong> from the dropdown menu.</li>
            <li>Select a <strong>Section</strong> from the dropdown menu.</li>
            <li>If you chose "With Subject", select a <strong>Subject</strong> from the dropdown menu.</li>
            <li>Click the <strong>Get Students</strong> button to retrieve the list of students based on the selected criteria.</li>
            <li>Check the checkboxes to select students and enter their <strong>Obtained Marks</strong> in the provided fields.</li>
            <li>Click the <strong>Save</strong> button to save the entered marks.</li>
            <li>To clear the form and start over, click the <strong>Cancel</strong> button.</li>


          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <StyledButton
            onClick={() => setShowUserGuide(false)}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#1898c2",
              "&:hover": { backgroundColor: "#156f9a" },
              borderRadius: "8px",
              px: 4,
            }}
          >
            Close
          </StyledButton>
        </DialogActions>
      </Dialog>

      <Paper
        elevation={3}
        style={{ padding: "20px", margin: "10px auto", maxWidth: "900px" }}
      >

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="session-label">Session</InputLabel>
              <Select
                labelId="session-label"
                value={session}
                onChange={handleSessionChange}
                label="Session"
                sx={{ height: 45 }}
              >
                <MenuItem value="" disabled>
                  Select Session
                </MenuItem>
                {sessions.map((item) => (
                  <MenuItem
                    key={item.financialYearID}
                    value={item.financialYearID}
                  >
                    {item.finanacialYear}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <RadioGroup
          row
          aria-label="subjectOption"
          name="subjectOption"
          value={subjectOption}
          onChange={handleSubjectOptionChange}
          style={{ marginBottom: "20px" }}
        >
          <FormControlLabel
            value="withSubject"
            control={<Radio />}
            label="With Subject"
          />
          {/* <FormControlLabel
            value="withoutSubject"
            control={<Radio />}
            label="Without Subject"
          /> */}
        </RadioGroup>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="exam-type-label">Exam Type</InputLabel>
             <Select
  labelId="exam-type-label"
  id="exam-type"
  value={selectedExamType}
  onChange={(e) => {
    setSelectedExamType(e.target.value);
    setSelectedSubExam("");
    setStudentList([]);
    setShowSaveCancel(false);
    setSelectAll(false);
  }}
  label="Exam Type"
>
                <MenuItem value="" disabled>
                  Select Exam Type
                </MenuItem>
                {examTypes.map((type) => (
                  <MenuItem key={type.examCriteriaId} value={type.examCriteriaId}>
                    {type.examType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth disabled={isSubExamDisabled}>
              <InputLabel id="sub-exam-label">Sub Exam</InputLabel>
              <Select
  labelId="sub-exam-label"
  id="sub-exam"
  value={selectedSubExam}
  onChange={(e) => {
    setSelectedSubExam(e.target.value);
    setStudentList([]);
    setShowSaveCancel(false);
    setSelectAll(false);
  }}
  label="Sub Exam"
>
                <MenuItem value="" disabled>
                  Select Sub Exam
                </MenuItem>
                {subExams.map((subExam) => (
                  <MenuItem key={subExam.id} value={subExam.id}>
                    {subExam.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="teacher-label">Teacher</InputLabel>
             <Select
  labelId="teacher-label"
  id="teacher"
  label="Teacher"
  value={selectedTeacher}
  onChange={(e) => {
    setSelectedTeacher(e.target.value);
    setSelectedClass("");
    setSelectedSection("");
    setSelectedSubject("");
    setStudentList([]);
    setShowSaveCancel(false);
    setSelectAll(false);
  }}
>
                <MenuItem value="" disabled>
                  Select Teacher
                </MenuItem>
                {teacherData.map((teacher) => (
                  <MenuItem key={teacher.employeeId} value={teacher.employeeId}>
                    {teacher.employeeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="class-label">Class</InputLabel>
             <Select
  labelId="class-label"
  id="class"
  label="Class"
  value={selectedClass}
  onChange={(e) => {
    setSelectedClass(e.target.value);
    setSelectedSection("");
    setSelectedSubject("");
    setStudentList([]);
    setShowSaveCancel(false);
    setSelectAll(false);
  }}
>
                <MenuItem value="" disabled>
                  Select Class
                </MenuItem>
                {classData.map((classItem) => (
                  <MenuItem key={classItem.classId} value={classItem.classId}>
                    {classItem.className}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="section-label">Section</InputLabel>
              <Select
  labelId="section-label"
  id="section"
  label="Section"
  value={selectedSection}
  onChange={(e) => {
    setSelectedSection(e.target.value);
    setSelectedSubject("");
    setStudentList([]);
    setShowSaveCancel(false);
    setSelectAll(false);
  }}
>
                <MenuItem value="" disabled>
                  Select Section
                </MenuItem>
                {sectionData.map((sectionItem) => (
                  <MenuItem
                    key={sectionItem.sectionId}
                    value={sectionItem.sectionId}
                  >
                    {sectionItem.sectionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {subjectOption === "withSubject" && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="subject-label">Subject</InputLabel>
                <Select
  labelId="subject-label"
  id="subject"
  label="Subject"
  value={selectedSubject}
  onChange={(e) => {
    setSelectedSubject(e.target.value);
    setStudentList([]);
    setShowSaveCancel(false);
    setSelectAll(false);
  }}
>
                  <MenuItem value="" disabled>
                    Select Subject
                  </MenuItem>
                  {Array.isArray(subjectData) &&
                    subjectData.map((subjectItem) => (
                      <MenuItem
                        key={subjectItem.subjectId}
                        value={subjectItem.subjectId}
                      >
                        {subjectItem.subjectName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGetStudents}
            style={{ marginLeft: "10px" }}
          >
            Get Students
          </Button>
        </div>
        {studentList.length > 0 && (
          <TableContainer component={Paper} style={{ marginTop: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Checkbox checked={selectAll} onChange={handleSelectAll} />
                  </TableCell>
                  <TableCell>Student Name</TableCell>
                  <TableCell>Roll No</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>Section</TableCell>
                  <TableCell>Subject</TableCell>
                  <TableCell>Max Marks</TableCell>
                  <TableCell>Min Marks</TableCell>
                  <TableCell>Obtained Marks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {studentList.map((student, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Checkbox
                        checked={student.checked || false}
                        onChange={(event) =>
                          handleCheckboxChange(index, event.target.checked)
                        }
                      />
                    </TableCell>
                    <TableCell>{student.studentName}</TableCell>
                    <TableCell>{student.rollNo}</TableCell>
                    <TableCell>{student.className}</TableCell>
                    <TableCell>{student.section}</TableCell>
                    <TableCell>{student.subjectName}</TableCell>
                    <TableCell>{student.maxMarks}</TableCell>
                    <TableCell>{student.minMarks}</TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        value={student.obtainedMarks || ""}
                        onChange={(event) => {
                          let newValue = event.target.value;
                          // Allow empty input or numbers between 0 and maxMarks
                          if (newValue === '' || (/^\d+$/.test(newValue) && parseInt(newValue) >= 0 && parseInt(newValue) <= student.maxMarks)) {
                            setStudentList((prevList) =>
                              prevList.map((prevStudent, idx) =>
                                idx === index
                                  ? { ...prevStudent, obtainedMarks: newValue }
                                  : prevStudent
                              )
                            );
                          }
                        }}
                        inputProps={{
                          min: 0,
                          max: student.maxMarks,
                          step: 1,
                        }}
                        onKeyDown={(e) => {
                          // Prevent negative sign, scientific notation, and decimals
                          if (['-', 'e', '+', '.'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
       {showSaveCancel && (
  <div style={{ textAlign: "center", marginTop: "20px" }}>
    <Tooltip title={canSave ? "Save Data" : "Not authorized to save"} arrow>
      <span>
        <Button
          variant="contained"
          color="primary"
          style={{ marginRight: "10px" }}
          onClick={handleSave}
          disabled={!canSave}
        >
          Save
        </Button>
      </span>
    </Tooltip>
    <Button variant="contained" color="secondary" onClick={clearForm}>
      Cancel
    </Button>
  </div>
)}

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Dialog open={openDialog} onClose={handleDialogClose}>
          <DialogTitle>Missing Information</DialogTitle>
          <DialogContent>
            Please select all required details before proceeding.
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </>
  );
};

export default AddExam;
